import Vue from 'vue'
import _ from 'lodash'

Vue.filter('truncate', (str, len, omission = '..') => {
  return _.truncate(str, {
    length: len || 20,
    omission: omission
  })
})
Vue.filter('toPercent', num => {
  return _.round((parseFloat(num) || 0) * 100, 2)
})

Vue.filter('removeTag', (str, replaceStr = '') => {
  if(str){
    str = _.trim(str.replace(/<[^>]+?>/g, replaceStr))
    str = _.trim(str.replace(/(\s+|&nbsp;)/g, ' '))
    return str
  }
  else{
    return ''
  }
  
})
Vue.filter('unescape', str => {
  return _.unescape(str || '')
})
Vue.filter('amountThousands2', (v, len = 4) => {
  return Vue._h.padZeroPlaces(Vue._h.toThousands(v, len))
})
Vue.filter('convertSpace', str => {
  str = str || ''
  str = str.replace(/\t/gm, _.repeat('&nbsp;', 4))
  return str
})

Vue.filter('hideStr', (str, type = 1, replace = '*') => {
  str = _.trim(str || '')
  if (!str) return '-'
  switch (type) {
    case 1:
      if (Vue._h.isPhoneNumber(str)) {
        str = str.replace(/^(\d{3})\d{5}/, '$1' + _.repeat('*', 5))
      } else {
        str = str.replace(/^(0\d{2,3}-?\d{2})\d{3}/, '$1' + _.repeat('*', 3))
      }
      break
    case 2:
      let strArr = str.split('@')
      str = strArr[0].substr(0, 3) + _.repeat('*', strArr[0].length > 6 ? strArr[0].length - 3 : 3) + '@' + strArr[1]
      break
  }
  return str
})

Vue.filter('rateValueConver', (str, tag = 'p', hasUnit = true) => {
  str = _.trim(str)
  if (!str) return '-'
  if (/^\d+?(\.\d+?)?%?$/.test(str)) {
    let rateNum = _.replace(str, /%$/, '')
    if (hasUnit) {
      return `${rateNum}<span class="unit">%</span>`
    } else {
      return rateNum
    }
  } else if (!/(\n|\r|\n\r|\r\n|\u21b5)/.test(str)) {
    return str
  } else {
    let rates = _.split(str, /(\n|\r|\n\r|\r\n|\u21b5)/)
    rates = Vue._.filter(rates, (v) => {
      v = Vue._.trim(Vue._.replace(v, '\u21b5', ''))
      return !Vue._.isEmpty(v)
    })
    if (tag) {
      return _.join(_.map(rates, (v) => {
        return `<${tag}>${_.trim(v)}</${tag}>`
      }), '')
    } else {
      return rates
    }
  }
})

Vue.filter('addUnit', (str, unit = '%') => {
  str = _.trim(str)
  if (!str) return '-'
  if (/^\d+?(\.\d+?)?%?$/.test(str)) {
    let rateNum = _.replace(str, /%$/, '')
    return `${rateNum}${unit}`
  }
  return str
})

Vue.filter('isMultiRate', (str) => {
  return /(\n|\r|\n\r|\r\n|\u21b5)/.test(_.trim(str))
})

Vue.filter('amountThousands', (v, len = 2) => {
  return Vue._h.padZeroPlaces(Vue._h.toThousands(v, len))
})
Vue.filter('padZeroPlaces', (v, len = 2) => {
  return Vue._h.padZeroPlaces(v, len)
})

Vue.filter('isPrice', (str) => {
  return /^\d+?(\.\d+?)?$/.test(str)
})

Vue.filter('rateValueAccording', (rate, rateDesc, tag = 'p') => {
  rate = _.trim(rate)
  rateDesc = _.trim(rateDesc || '')
  if (!rate) return rateDesc || '-'
  if (rate.length > rateDesc.length) {
    if (/^\d+?(\.\d+?)?%?$/.test(rate)) {
      let rateNum = _.replace(rate, /%$/, '')
      return `${rateNum}<span class="unit">%</span>`
    } else if (!/(\n|\r|\n\r|\r\n|\u21b5)/.test(rate)) {
      return rate
    } else {
      let rates = _.split(rate, /(\n|\r|\n\r|\r\n|\u21b5)/)
      rates = Vue._.filter(rates, (v) => {
        v = Vue._.trim(Vue._.replace(v, '\u21b5', ''))
        return !Vue._.isEmpty(v)
      })
      if (tag) {
        return _.join(_.map(rates, (v) => {
          return `<${tag}>${_.trim(v)}</${tag}>`
        }), '')
      } else {
        return rates
      }
    }
  } else {
    return rateDesc
  }
})

Vue.filter('rateValueReturn', (rate, rateDesc) => {
  rate = _.trim(rate)
  rateDesc = _.trim(rateDesc || '')
  if (!rate) return rateDesc
  if (rate.length > rateDesc.length) {
    return rate
  } else {
    return rateDesc
  }
})

Vue.filter('rateIsAvailable', (v) => {
  v = _.trim(v)
  if (!v) return false
  return /^\d+?(\.\d+?)?%?$/.test(v)
})

Vue.filter('isSpecialHSCode', (v) => {
  v = _.trim(v)
  return /^\*/.test(v)
})

Vue.filter('specialHSCodeValue', (v, replaceStr = '-') => {
  if (Vue.filter('isSpecialHSCode')(v)) {
    return replaceStr
  } else {
    return v
  }
})

Vue.filter('chartIndicate', (index, len, startIndex = 1) => {
  if (len === 1) {
    return `l3`
  } else {
    if (startIndex === 1 && index === 1 && len === 2) {
      return `l3`
    } else {
      let resIndex = startIndex + index
      if (resIndex > 3) resIndex = 3
      return `l${resIndex}`
    }
  }
})

Vue.filter('getMaterialType', (key, isReturn) => {
  let maps = { 'material': '\u539f\u6750\u6599', 'p-packaging': '\u96f6\u552e\u5305\u88c5\u6750\u6599\u548c\u5bb9\u5668', 't-packaging': '\u8fd0\u8f93\u548c\u88c5\u8fd0\u7528\u5305\u6750\u548c\u5bb9\u5668' , 'i-material': '\u95f4\u63a5\u6750\u6599' , 'a-record': '\u9644\u4ef6\u3001\u5907\u4ef6\u548c\u5de5\u5177', 'e-cost': '\u4f01\u4e1a\u5176\u4ed6\u6210\u672c', 'e-profit': '\u4f01\u4e1a\u5229\u6da6' }
  if (isReturn) {
    return maps
  } else {
    return key ? maps[key] || '' : ''
  }
})
Vue.filter('getIntegralUsedType', (val = null) => {
  let values = [{name: '\u6d88\u8017', value: 1}, {name: '\u5145\u503c', value: 2}, {name: '\u8d60\u9001', value: 3}, {name: '\u8fd4\u5229', value: 4}]
  if (val) {
    return _.find(values, function (o) { return o.value === parseInt(val) }) || {}
  } else {
    return values
  }
})
Vue.filter('getInvoiceType', (val = null) => {
  let values = [{name: '\u4f01\u4e1a', value: 1}, {name: '\u4e2a\u4eba', value: 2}]
  if (val) {
    return _.find(values, function (o) { return o.value === parseInt(val) }) || {}
  } else {
    return values
  }
})
Vue.filter('getInvoiceVat', (val = null) => {
  let values = [{name: '\u666e\u901a\u53d1\u7968', value: 1}, {name: '\u589e\u503c\u7a0e\u53d1\u7968', value: 2}]
  if (val) {
    return _.find(values, function (o) { return o.value === parseInt(val) }) || {}
  } else {
    return values
  }
})
Vue.filter('getInvoiceStatus', (val = null) => {
  let values = [{name: '\u7533\u8bf7\u4e2d', value: 1, className: 'doing'}, {name: '\u5df2\u5f00\u7968', value: 2, className: 'success'}, {name: '\u5f00\u7968\u5931\u8d25', value: -1, className: 'error'}]
  if (val) {
    return _.find(values, function (o) { return o.value === parseInt(val) }) || {}
  } else {
    return values
  }
})
Vue.filter('getVipTypeName', (val = null) => {
  let values = [{name: '\u6708\u5361', value: 1}, {name: '\u5b63\u5361', value: 2}, {name: '\u5e74\u5361', value: 3}]
  if (val) {
    return _.find(values, function (o) { return o.value === parseInt(val) }) || {}
  } else {
    return values
  }
})
Vue.filter('getMCardAfterMonthsTimestamp', (begin, vipVal, num) => {
  var ms = 1
  switch (vipVal) {
    case 2:
      ms = 3
      break
    case 3:
      ms = 12
      break
  }
  return Vue._h.getAfterMonths(begin, ms * num)
})
Vue.filter('getVipType', (type, vip) => {
  let name = ''
  if (type === 1) {
    name = '\u666e\u901a\u5957\u9910'
  } else {
    switch (vip) {
      case 1:
        name = '\u6708\u5361'
        break
      case 2:
        name = '\u5b63\u5361'
        break
      case 3:
        name = '\u5e74\u5361'
        break
    }
  }
  return name
})
Vue.filter('getVipIcon', (type, vip) => {
  let name = ''
  if (type === 2) {
    switch (vip) {
      case 1:
        name = 'yk'
        break
      case 2:
        name = 'jk'
        break
      case 3:
        name = 'nk'
        break
    }
  }
  return name
})
Vue.filter('getCompanyRole', (val, isGetDict = false) => {
  let values = [{name: '\u8fdb\u53e3\u5546', value: 1}, {name: '\u51fa\u53e3\u5546', value: 2}]
  if (isGetDict) {
    return values
  } else {
    if (!val) return '-'
    let res = []
    _.forEach(_.split(val, ','), (v) => {
      let item = _.find(values, function (o) { return o.value === parseInt(v) })
      if (item) res.push(item.name)
    })
    return res.join(',') || '-'
  }
})
Vue.filter('getApiValueID', (name) => {
  let res = 1
  switch (name) {
    case 'rate':
      res = 1
      break
    case 'rules':
      res = 2
      break
    case 'hscode':
      res = 3
      break
  }
  return res
})
Vue.filter('getCooStatus', status => {
  status = parseInt(status)
  if (status == 0 || status == -1) {
    return '\u5224\u5b9a\u672a\u901a\u8fc7'
  } else if (status == 1) {
    return '\u5f85\u5224\u5b9a'
  } else if (status == 2) {
    return '\u5224\u5b9a\u901a\u8fc7'
  } else if (status == 10) {
    return '\u5df2\u5f52\u6863'
  } else {
    return '-'
  }
})
Vue.filter('ieFlagDict', key => {
  let _map = { 'I': '\u8fdb\u53e3', 'E': '\u51fa\u53e3' }
  return key? _map[key] : _map
})
Vue.filter('feeModeDict', key => {
  let _map = { '1': '\u603b\u4ef7', '2': '\u8d39\u7387', '3': '\u5355\u4ef7(\u5428)' }
  return key ? _map[key + ''] || key : _map
})
Vue.filter('benefitStatusDict', key => {
  let _map = { '1': '\u5df2\u4eab\u60e0', '0': '\u672a\u4eab\u60e0', '2': '\u6709\u4eab\u60e0\u673a\u4f1a' }
  return key || key === 0 || key === '0' ? _map[key + ''] || key : _map
})
Vue.filter('benefitErrorCode', key => {
  let _map = { '1001': '\u7a0e\u53f7\u4e0d\u5b58\u5728', '1002': '\u8d77\u8fd0\u5730\u6216\u539f\u4ea7\u56fd\u4e0d\u5b58\u5728', '1003': '\u76d1\u7ba1\u65b9\u5f0f\u4e0d\u652f\u6301', '1004': '\u6210\u4ea4\u65b9\u5f0f\u4e0d\u652f\u6301', '1005': '\u5e01\u5236\u6c47\u7387\u4e0d\u652f\u6301' }
  return key ? _map[key + ''] : ''
})


// WEBPACK FOOTER //
// ./src/assets/js/filters.js